import { memo } from "react";
import { ActionButtons } from "./action-buttons";
import * as Styled from "./style";
import { TagTitle } from "./tag-title";
import type { G_GetVideoQuery } from "~/lib/graphql";

type ProductTitleProps = {
  videoData: G_GetVideoQuery["video"];
};

export const ProductTitle = memo((props: ProductTitleProps) => {
  const { videoData } = props;

  return (
    <Styled.DivProductTitleFlexContainer>
      <TagTitle videoData={videoData} />
      <ActionButtons videoData={videoData} />
    </Styled.DivProductTitleFlexContainer>
  );
});

ProductTitle.displayName = "ProductTitle";
